import { Injectable, inject } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { mergeMap, tap } from 'rxjs';
import { PermissionService } from '../../services';
import * as actions from './permission.actions';

@State<void>({ name: 'permission' })
@Injectable({ providedIn: 'root' })
export class PermissionState {
  permissionService = inject(PermissionService);

  @Action(actions.CreatePermission)
  create(
    { dispatch }: StateContext<void>,
    { permission }: actions.CreatePermission
  ) {
    return this.permissionService
      .post(permission)
      .pipe(
        mergeMap((data) => dispatch(new actions.GetPermissionResponse(data)))
      );
  }

  @Action(actions.UpdatePermission)
  update(
    { dispatch }: StateContext<void>,
    { permission }: actions.UpdatePermission
  ) {
    return this.permissionService
      .patch(permission)
      .pipe(
        mergeMap((data) => dispatch(new actions.GetPermissionResponse(data)))
      );
  }

  @Action(actions.ActivatePermission)
  activate(
    { dispatch }: StateContext<void>,
    { permission }: actions.ActivatePermission
  ) {
    return this.permissionService
      .activate(permission)
      .pipe(tap((data) => dispatch(new actions.GetPermissionResponse(data))));
  }

  @Action(actions.DeletePermission)
  delete(
    context: StateContext<void>,
    { permission }: actions.DeletePermission
  ) {
    return this.permissionService.delete(permission._id);
  }

  @Action(actions.RestorePermission)
  restore(
    context: StateContext<void>,
    { permission }: actions.RestorePermission
  ) {
    return this.permissionService.restore(permission._id);
  }

  @Action(actions.GetPermission)
  getOne({ dispatch }: StateContext<void>, { id }: actions.GetPermission) {
    return this.permissionService
      .getOne(id)
      .pipe(tap((data) => dispatch(new actions.GetPermissionResponse(data))));
  }

  @Action(actions.SearchPermissions)
  get({ dispatch }: StateContext<void>, { data }: actions.SearchPermissions) {
    let obs = null;
    if (data.condition) obs = this.permissionService.search(data);
    else obs = this.permissionService.get(data);

    return obs.pipe(
      tap((data) =>
        dispatch(new actions.GetPermissionsResponse(data, { state: 'success' }))
      )
    );
  }
}
